import { render, staticRenderFns } from "./TagGroupDashboard.vue?vue&type=template&id=762bdf88&scoped=true&lang=html&"
import script from "./TagGroupDashboard.vue?vue&type=script&lang=js&"
export * from "./TagGroupDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TagGroupDashboard.vue?vue&type=style&index=0&id=762bdf88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762bdf88",
  null
  
)

export default component.exports